export interface IDisplayTextProps {text: string}

const DisplayText: React.FC<IDisplayTextProps> = ({text}) => {
    return <p className={"standardText"}>{text}</p>
}

export default DisplayText;